import React from 'react';
import {
  StackLayout,
  GDSStyleObject,
  Card,
  ParagraphText,
  useMediaQuery,
  queryHelpers,
  Box,
} from '@leagueplatform/genesis-core';
import { Accordion } from '@leagueplatform/web-common-components';
import { HtmlToReact } from '@leagueplatform/web-common';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';

export function EasyPlanAccordionComponent(props: any) {
  const { faqInfoLoading, faqApiFailure, faqInformation } = props;

  const isBetweenDownSizeMobile = useMediaQuery(
    queryHelpers.between([300, 399]),
  );

  const trackAnalytics = (
    buttonName: string,
    product: string,
    accordionState: string,
    event: Event,
  ) => {
    if (
      (event?.currentTarget as HTMLInputElement).getAttribute('data-state') ===
      'closed'
    ) {
      trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
        product_area: product,
        screen_name: 'FAQ Page',
        detail: `toggle ${buttonName} accordion`,
        sub_detail: accordionState,
        path: window.location.pathname,
        event_author: 'engen',
      });
    } else {
      trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
        product_area: product,
        screen_name: 'FAQ Page',
        detail: `toggle ${buttonName} accordion`,
        sub_detail: 'collapse',
        path: window.location.pathname,
        event_author: 'engen',
      });
    }
  };

  return (
    <Card.Flat css={{ width: '100%', borderRadius: '$none' }}>
      <Card.Section
        css={
          {
            boxSizing: 'border-box',
            padding: '$none',
            '@desktop': {
              width: '100%',
            },
            '@mobile': {
              width: '100vw',
            },
          } as GDSStyleObject
        }
      >
        <StackLayout
          orientation="horizontal"
          spacing={{ '@desktop': '$two' }}
          css={
            {
              width: '100%',
              display: 'block',
              '@mobile': {},
            } as GDSStyleObject
          }
        >
          <Accordion.Root
            type="single"
            data-testid="faqPanel"
            css={{
              '& .GDS-button:focus': {
                outline: 0,
                border: '3px solid #0074C9',
                backgroundColor: '$surfaceBackgroundPrimary',
                '@mobile': {
                  width: '100% !important',
                },
              },
              '& .GDS-button:hover': {
                outline: 0,
                backgroundColor: '$surfaceBackgroundTertiary',
              },
              '& .GDS-button span': {
                lineHeight: '$bodyOne',
                '@mobile': {
                  width: isBetweenDownSizeMobile ? '320px' : '370px',
                },
              },
            }}
            collapsible
          >
            {!faqInfoLoading &&
              faqApiFailure === false &&
              faqInformation?.easyPlanFaq?.map((item: any, index: any) => (
                <Accordion.Item
                  key={item?.question}
                  value={`${index}-3`}
                  css={{
                    marginTop: '$none !important',
                    borderRadius: '0px',
                    '@mobile': {
                      // is unavoidable added !important
                      width: isBetweenDownSizeMobile
                        ? '100vw !important'
                        : '100vw !important',
                    },
                    visited: {
                      border: '1px solid #000000 !important',
                    } as GDSStyleObject,
                  }}
                >
                  <Accordion.Header
                    css={
                      {
                        borderRadius: '0px',
                        border: '0px solid #000000 !important',
                        '@desktop': {
                          borderRadius: '0px',
                        },
                        '@mobile': {
                          // is unavoidable added !important
                          width: isBetweenDownSizeMobile
                            ? '100% !important'
                            : '100% !important',
                        },
                      } as GDSStyleObject
                    }
                    data-testid="FaqExpandCollapse"
                    onClick={(event: Event) =>
                      trackAnalytics(item?.question, 'faq', 'expand', event)
                    }
                  >
                    <Box
                      css={{
                        borderBottom: '1px solid $onSurfaceBorderSubdued',
                        '@mobile': {
                          marginLeft: isBetweenDownSizeMobile ? '-1px' : '-1px',
                          width: isBetweenDownSizeMobile ? '100%' : '100%',
                        },
                      }}
                    >
                      <Accordion.Trigger
                        css={
                          {
                            color: '$onSurfaceTextPrimary',
                            LineHeight: '$bodyOne',
                            borderRadius: '0px',
                            padding: '$oneAndHalf $oneAndHalf !important',
                            fontWeight: '$buttonOne !important',
                            '@desktop': {
                              width: '714px',
                              fontSize: '$headingThree !important',
                            },
                            '@mobile': {
                              fontSize: '$subtitleOne',
                              lineHeight: '$bodyOne',
                              letterSpacing: '-0.2px  !important',
                            },
                          } as GDSStyleObject
                        }
                      >
                        {item?.question}
                      </Accordion.Trigger>
                    </Box>
                  </Accordion.Header>
                  <Accordion.Content
                    css={{
                      backgroundColor: '$surfaceBackgroundSecondary',
                      '@mobile': {
                        width: '100%',
                      },
                    }}
                  >
                    <ParagraphText
                      css={
                        {
                          fontWeight: 400,
                          fontSize: '$bodyOne',
                          lineHeight: '24px',
                          backgroundColor: '$surfaceBackgroundSecondary',
                          borderRadius: '0px',
                          borderBottom:
                            '1px solid $onSurfaceBorderSubdued !important',
                          marginTop: '-17px',
                          '@desktop': {
                            padding: '$one $oneAndHalf',
                            fontSize: '$bodyOne',
                            marginTop: '-17px',
                          },
                          '@tablet': {
                            padding: '$one $oneAndHalf',
                            fontSize: '$bodyOne',
                            textAlign: 'justify',
                          },
                          '@mobile': {
                            padding: '$one $oneAndHalf',
                            fontSize: '$bodyOne',
                            width: '100%',
                            textAlign: 'left',
                          },
                        } as GDSStyleObject
                      }
                      key={item?.answer?.length}
                    >
                      <HtmlToReact htmlString={item?.answer} />
                    </ParagraphText>
                  </Accordion.Content>
                </Accordion.Item>
              ))}
          </Accordion.Root>
        </StackLayout>
      </Card.Section>
    </Card.Flat>
  );
}
